export default "__VITE_ASSET__e3ccf7ef__"